import React from 'react';

import { ButtonInnerWithLoadingState } from '../../Button/ButtonInner/ButtonInnerWithLoadingState';
import type { ButtonTextColorMode, CommonButtonProps } from '../../Button/types';
import * as styles from './styles';
import { buttonSize } from '../buttonSizes.styles';

export interface RoundButtonProps extends CommonButtonProps {
  size: 'small' | 'large';
  textColorMode?: ButtonTextColorMode;
}

/** @deprecated use `IconButton` instead */
export const RoundButton = ({
  active,
  children,
  id = '',
  onClick,
  size,
  textColorMode = 'brand',
  ...props
}: RoundButtonProps) => (
  <button
    css={[
      styles.roundButtonBase,
      buttonSize(false, false),
      styles.buttonOverrides,
      size === 'small' ? styles.small : styles.large,
    ]}
    data-is-active={active}
    id={id}
    onClick={onClick}
    {...props}
  >
    <ButtonInnerWithLoadingState compact={false} loading={false} textColorMode={textColorMode}>
      {children}
    </ButtonInnerWithLoadingState>
  </button>
);
